import React from 'react';
import {useIntl} from 'react-intl';
import ErrorPage from '../../common/ErrorPage/ErrorPage';
import PageTitle from '../PageTitle';
import {KBA_UNAVAILABLE_ERROR_KEY, ACCESS_DENIED_TITLE_KEY} from './constants';
import {useIsDashboardLinkVisible} from './hooks/useIsDashboardLinkVisible';

export function KbaUnavailable() {
    const intl = useIntl();
    const isDashboardLinkVisible = useIsDashboardLinkVisible();

    const titleKey = ACCESS_DENIED_TITLE_KEY;
    const messageKey = KBA_UNAVAILABLE_ERROR_KEY;

    const customTitleMessage = intl.formatMessage({id: titleKey, defaultMessage: 'Access Denied'});
    const customErrorMessage = intl.formatMessage({id: messageKey, defaultMessage: 'Knowledge-based authentication is not available for this user'});

    return (
        <>
            <PageTitle pageTitle={customTitleMessage} />
            <ErrorPage
                isDashboardLinkVisible={isDashboardLinkVisible}
                customTitleMessage={customTitleMessage}
                customErrorMessage={customErrorMessage}
            />
        </>
    );
}
